import { Link } from "react-router-dom"
import Login from "../Login/Login"

const Landing = () => {
  return <div className='Landing'>
    <div className='w3-container'>Auf dieser Seite kann man sich einloggen, wenn man berechtigt ist.</div>
    <Login></Login>
  </div>
}
export default Landing